import { AppState } from '../reducers/RootReducer';
import { createSelector } from 'reselect';
import { IExerciseGroup } from '../models/Models';

const getExerciseGroups = (state: AppState): Array<IExerciseGroup> => state.exerciseGruops.exerciseGroups;

export const getExerciseGroupsSelector = createSelector(getExerciseGroups, (exerciseGroups) => exerciseGroups);
